import { render, staticRenderFns } from "./dialogue-box.vue?vue&type=template&id=acfcaada&scoped=true"
import script from "./dialogue-box.vue?vue&type=script&lang=js"
export * from "./dialogue-box.vue?vue&type=script&lang=js"
import style0 from "./dialogue-box.vue?vue&type=style&index=0&id=acfcaada&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfcaada",
  null
  
)

export default component.exports